import React from "react";
import {cn} from "../utils";

const InvoiceIcon = (
    {
        className,
        color
    }: {
        className?: string,
        color?: string
    } & React.SVGProps<SVGSVGElement>) => (
    <svg fill="none"
         height="512"
         viewBox="0 0 24 24"
         width="512"
         className={cn(className)}
         xmlns="http://www.w3.org/2000/svg"
    >
        <g fill={color || "currentColor"}>
            <path
                d="m7 2.75h10v-1.5h-10zm13.25 3.25v12h1.5v-12zm-3.25 15.25h-10v1.5h10zm-13.25-3.25v-12h-1.5v12zm3.25 3.25c-1.79493 0-3.25-1.4551-3.25-3.25h-1.5c0 2.6234 2.12665 4.75 4.75 4.75zm13.25-3.25c0 1.7949-1.4551 3.25-3.25 3.25v1.5c2.6234 0 4.75-2.1266 4.75-4.75zm-3.25-15.25c1.7949 0 3.25 1.45507 3.25 3.25h1.5c0-2.62335-2.1266-4.75-4.75-4.75zm-10-1.5c-2.62335 0-4.75 2.12665-4.75 4.75h1.5c0-1.79493 1.45507-3.25 3.25-3.25z"/>
            <path
                d="m17 7.75c.4142 0 .75-.33579.75-.75s-.3358-.75-.75-.75zm-10-1.5c-.41421 0-.75.33579-.75.75s.33579.75.75.75zm10 0h-10v1.5h10z"/>
            <path
                d="m17 12.75c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm-10-1.5c-.41421 0-.75.3358-.75.75s.33579.75.75.75zm10 0h-10v1.5h10z"/>
            <path
                d="m12 17.75c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75zm-5-1.5c-.41421 0-.75.3358-.75.75s.33579.75.75.75zm5 0h-5v1.5h5z"/>
        </g>
    </svg>

);

export {InvoiceIcon};